import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit';
import { baseApi } from '../services/baseApi';
import { paymentApi } from '../services/paymentApi';

const storeOptions: ConfigureStoreOptions = {
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(baseApi.middleware, paymentApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
};

export const store = configureStore(storeOptions);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
